import clsx from 'clsx'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
import { InternalLink } from '../../const/Links'
import type { ProductFeatureResult } from '../../data/ProductFeatureFragment'
import style from './SummaryList.module.sass'
import { TitleIconSmall } from './TitleIconSmall'

type SummaryListProps = {
	small?: boolean
	summaryCategory: {
		title: string
		icon: JSX.Element
		values?: ProductFeatureResult[]
		id: string
	}
	extraContent?: JSX.Element
}

export const SummaryList: FunctionComponent<SummaryListProps> = ({ summaryCategory, extraContent, small }) => {
	return (
		<>
			<TitleIconSmall title={summaryCategory.title} icon={summaryCategory.icon} />
			<ul>
				{summaryCategory.values &&
					summaryCategory.values.length > 0 &&
					summaryCategory.values.map((value) => (
						<li key={value.id} className={clsx(style.listItem, value.linkItem && style.listItemUrl, small && style.small)}>
							{value.linkItem ? (
								<Link
									href={`${InternalLink.Ingredient}${value.linkItem.slug}`}
									className={style.link}
									title={summaryCategory.title}
								>
									{value.text}
								</Link>
							) : (
								value.dependentCategory && (
									<Link
										title={summaryCategory.title}
										href={`${InternalLink.IngredientCategory}${value.dependentCategory.slug}`}
										className={style.link}
									>
										{value.text}
									</Link>
								)
							)}
							{!value.linkItem && !value.dependentCategory && <span>{value.text}</span>}
						</li>
					))}
				{extraContent}
			</ul>
		</>
	)
}
